import { bool, number, string, oneOfType, object, node } from "prop-types";
import { Divider, Tooltip } from "@material-ui/core";
import useStyle from "../Totals.style";
import classnames from "classnames";
import { NumericFormat } from "react-number-format";

export const TotalValue = ({
  min,
  max,
  symbolStart,
  symbolEnd,
  showMaxValue,
  showDecimals,
  fixedDecimalScale,
  americanFormat,
  minTooltipMessage,
  maxTooltipMessage,
  style,
  decimals=2,
  showAllSymbols=false,
  allowNegative=false,
  applySuffixSpacing=false,
}) => {
  const classes = useStyle();
  
  const formatterProps = {
    allowNegative,
    decimalScale: showDecimals || fixedDecimalScale ? decimals : 0,
    fixedDecimalScale,
    thousandSeparator: americanFormat ? "," : " ",
    decimalSeparator: ".",
    allowedDecimalSeparators: [",", "."],
    valueIsNumericString: true,
    displayType: "text",
    className: "white-space-pre",
    style,
  };
  
  const suffix = applySuffixSpacing && Boolean(symbolEnd) ? ` ${symbolEnd.trim()}` : symbolEnd;
  
  return (
    <>
      {
        minTooltipMessage
          ? <Tooltip title={ minTooltipMessage }>
            <span>
              <NumericFormat
                value={min}
                prefix={symbolStart}
                suffix={showAllSymbols || !showMaxValue ? suffix : undefined}
                {...formatterProps}
              />
            </span>
          </Tooltip>
          : <NumericFormat
            value={min}
            prefix={symbolStart}
            suffix={showAllSymbols || !showMaxValue ? suffix : undefined}
            {...formatterProps}
          />
      }
      {
        showMaxValue &&
        <Divider className={classnames("total-divider", classes.totalValueDivider)} />
      }
      {
        showMaxValue && (
          maxTooltipMessage
            ? <Tooltip title={ maxTooltipMessage }>
              <span>
                <NumericFormat
                  value={max}
                  prefix={showAllSymbols ? symbolStart : undefined}
                  suffix={suffix}
                  {...formatterProps}
                />
              </span>
            </Tooltip>
            : <NumericFormat
              value={max}
              prefix={showAllSymbols ? symbolStart : undefined}
              suffix={suffix}
              {...formatterProps}
            />
        )
      }
    </>
  )
}

TotalValue.propTypes = {
  min: oneOfType([number, string]).isRequired,
  max: oneOfType([number, string]),
  symbolStart: string,
  symbolEnd: oneOfType([node, string]),
  showMaxValue: bool,
  style: object,
  showDecimals: bool,
  fixedDecimalScale: bool,
  decimals: number,
  allowNegative: bool,
  americanFormat: bool,
  showAllSymbols: bool,
  applySuffixSpacing: bool,
  minTooltipMessage: node,
  maxTooltipMessage: node,
}